import { IFilters } from 'coreOld/types';

import FilterField from './FilterField';
import { FieldWrapper, FiltersBar, Section } from './filtersStyle';

interface IProps extends IFilters {
  onChangeAdvancedFilter?: (name: string, value: number | string, clearFilters?: boolean) => void;
  onApplyAdvancedFilters?: () => void;
}

const FiltersView = ({
  onChangeFilter,
  onChangeAdvancedFilter,
  onApplyAdvancedFilters,
  onAdd,
  values,
  advancedFiltersValues,
  filtersConfig,
  advancedFiltersConfig,
}: IProps) => {
  return (
    <FiltersBar>
      {filtersConfig.map((filter) => (
        <Section
          key={filter.name}
          border={filter.border}
          style={{
            flex: filter.flex,
            height: filter.height,
            paddingRight: filter.paddingRight,
            paddingLeft: filter.paddingLeft,
          }}
        >
          <FieldWrapper
            style={{
              width: filter.width,
              minWidth: filter.minWidth,
            }}
          >
            <FilterField
              values={values}
              advancedFiltersValues={advancedFiltersValues}
              filter={filter}
              onAdd={onAdd}
              onChangeFilter={onChangeFilter}
              onChangeAdvancedFilter={onChangeAdvancedFilter}
              advancedFiltersConfig={advancedFiltersConfig}
              onApplyAdvancedFilters={onApplyAdvancedFilters}
            />
          </FieldWrapper>
        </Section>
      ))}
    </FiltersBar>
  );
};

export default FiltersView;
